import { TLogo } from '@/features/logos/types';

/**
 * Counts how many logo presences match the active labels filter.
 *
 * A presence matches when the logo it references (via `logo_id`) has at least
 * one label included in `selectedLabelIds`. When no labels are selected the
 * filter is inactive and every presence counts.
 */
export function countLogosByLabels(
  logoPresences: ReadonlyArray<{ logo_id?: string }>,
  selectedLabelIds: ReadonlyArray<string>,
  logosById: Record<string, TLogo>
): number {
  if (selectedLabelIds.length === 0) {
    return logoPresences.length;
  }

  const selected = new Set(selectedLabelIds);

  return logoPresences.filter(presence => {
    const labels = presence.logo_id ? logosById[presence.logo_id]?.labels : undefined;
    return labels?.some(labelId => selected.has(labelId)) ?? false;
  }).length;
}
